import React, { useState } from 'react';
import './ToggleViewHumanLoss.css';

export default function ToggleViewHumanLoss({ activeTabBmsk, setActiveTabBmsk }) {

    const handleTabClick = (tabName) => {
        setActiveTabBmsk(tabName);

    };

    return (
        <div className="toggle-switch-container">
             <div
                className={`toggle-item ${activeTabBmsk === 'Charts' ? 'active' : ''}`}
                onClick={() => handleTabClick('Charts')}
            >
                Charts
            </div>
            <div
                className={`toggle-item ${activeTabBmsk === 'Table' ? 'active' : ''}`}
                onClick={() => handleTabClick('Table')}
            >
                Table
            </div>
        </div>
    );
}
